import React from "react";
import Icons from "Common/Icons";
import { Button } from "antd";
import "./Styles/BackButton.scss";


class BackButton extends React.Component{
    constructor(props){
        super(props);
        this.state={
        }
    }

    render(){
       return(
             <Button className="back-btn" onClick={()=>this.props.navigateBackPage()}>
                <img className="back-btn-img" src={Icons.back_btn_icon}/>
                Back
            </Button>
       )
    }
}

export default BackButton;